import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Building2, MapPin, ShieldCheck, BookHeart, GraduationCap, Users } from "lucide-react";

export default function FranquiciadoFranquicia() {
  const { user } = useAuth();
  const [f, setF] = useState(null);
  const [counts, setCounts] = useState({ admins: 0, docentes: 0, estudiantes: 0 });

  const load = async () => {
    if (!user?.franchise_id) return;
    const { data } = await api.get(`/franchises/${user.franchise_id}`);
    setF(data);
    // Conteos reales por rol (incluye admin franquicia)
    try {
      const [a, d, e] = await Promise.all([
        api.get("/users", { params: { role: "admin" } }),
        api.get("/users", { params: { role: "docente" } }),
        api.get("/users", { params: { role: "estudiante" } }),
      ]);
      setCounts({
        admins: (a.data || []).length,
        docentes: (d.data || []).length,
        estudiantes: (e.data || []).length,
      });
    } catch { /* sin permisos */ }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [user?.franchise_id]);

  if (!f) return <div className="jasq-card p-10 text-center text-sm text-[#6E7591]">Cargando…</div>;

  const total = counts.admins + counts.docentes + counts.estudiantes;

  return (
    <div className="space-y-6 max-w-3xl" data-testid="franquiciado-franquicia">
      <div>
        <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#F5B82E]">Mi franquicia</p>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#1F2547]">{f.name}</h1>
        <p className="text-sm text-[#6E7591] mt-1">Información general de tu sede. Para cambios mayores contacta al administrador central.</p>
      </div>

      <div className="jasq-card p-5 space-y-4">
        <div className="flex items-start gap-4">
          {f.logo_url ? (
            <img src={f.logo_url} alt={f.name} className="w-20 h-20 rounded-2xl object-cover border-2 border-[#E1E5F0] shrink-0" data-testid="franchise-logo" />
          ) : (
            <span className="w-20 h-20 rounded-2xl bg-[#F5B82E]/15 text-[#F5B82E] flex items-center justify-center shrink-0"><Building2 size={28} /></span>
          )}
          <div className="flex-1 min-w-0 space-y-2">
            <RoLine k="ID" v={<span className="font-mono">{f.franchise_id}</span>} />
            <RoLine k="Nombre comercial" v={f.name} />
            <RoLine k="Ciudad" v={f.city || "—"} />
            <RoLine k="País" v={
              <span className="inline-flex items-center gap-1.5">
                <MapPin size={12} className="text-[#6E7591]" /> {f.country || "—"}
              </span>
            } />
            {f.email_contact && <RoLine k="Contacto" v={f.email_contact} />}
            {f.phone_contact && <RoLine k="Teléfono" v={f.phone_contact} />}
          </div>
        </div>
      </div>

      <div className="jasq-card p-5">
        <div className="flex items-end justify-between mb-3">
          <h3 className="font-display font-extrabold text-[#1F2547]">Resumen de usuarios</h3>
          <p className="text-[11px] tracking-wider uppercase font-bold text-[#6E7591]" data-testid="resumen-total">Total: <b className="text-[#1F2547]">{total}</b></p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 text-center">
          <SummaryTile color="#FFF3D6" iconBg="#F5B82E" Icon={ShieldCheck} value={counts.admins} label="Admin Franquicia" testid="kpi-admins" />
          <SummaryTile color="#E2EBFF" iconBg="#2C49A0" Icon={GraduationCap} value={counts.docentes} label="Docentes" testid="kpi-docentes" />
          <SummaryTile color="#FFE6F1" iconBg="#D63384" Icon={BookHeart} value={counts.estudiantes} label="Estudiantes" testid="kpi-estudiantes" />
          <SummaryTile color="#F0F2FA" iconBg="#1F2547" Icon={Users} value={total} label="Total usuarios" testid="kpi-total" />
        </div>
      </div>
    </div>
  );
}

function RoLine({ k, v }) {
  return (
    <div className="flex items-baseline gap-3">
      <span className="text-[11px] uppercase tracking-wider font-extrabold text-[#6E7591] min-w-[130px]">{k}</span>
      <span className="font-bold text-[#1F2547] text-sm">{v}</span>
    </div>
  );
}

function SummaryTile({ color, iconBg, Icon, value, label, testid }) {
  return (
    <div className="p-3 rounded-xl flex flex-col items-center gap-1.5" style={{ background: color }} data-testid={testid}>
      <span className="w-9 h-9 rounded-xl flex items-center justify-center text-white" style={{ background: iconBg }}>
        <Icon size={16} />
      </span>
      <p className="font-display text-2xl font-extrabold text-[#1F2547]">{value}</p>
      <p className="text-[11px] uppercase tracking-wider font-bold text-[#6E7591]">{label}</p>
    </div>
  );
}
